"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.mkImpressionData = void 0;
var c = function (arg) {
    if (typeof arg === "string")
        return arg;
    return null;
};
var mkImpressionData = function (req, args) {
    var _a = req.query, source = _a.source, utm_source = _a.utm_source, campaign = _a.campaign, utm_campaign = _a.utm_campaign, content = _a.content, utm_content = _a.utm_content, term = _a.term, utm_term = _a.utm_term, medium = _a.medium, utm_medium = _a.utm_medium, rest = __rest(_a, ["source", "utm_source", "campaign", "utm_campaign", "content", "utm_content", "term", "utm_term", "medium", "utm_medium"]);
    var a = {
        source: c(source) || c(utm_source),
        medium: c(medium) || c(utm_medium),
        term: c(term) || c(utm_term),
        campaign: c(campaign) || c(utm_campaign),
        content: c(content) || c(utm_content),
        ip_country_code: null,
        ip: null,
        url: new URL(req.protocol + "://" + req.get("host") + req.originalUrl).href,
        headers: {
            "accept-language": c(req.headers["accept-language"]),
            referer: c(req.headers["referer"]),
            "user-agent": c(req.headers["user-agent"]),
        },
        query_string: rest,
        args: args,
    };
    return a;
};
exports.mkImpressionData = mkImpressionData;
